export default "__VITE_ASSET__DRE4$nHH__"